import React, { useState } from 'react';
import { addServiceData } from '../../../Services/ServicedataApi';

function Servicedata() {
    const [formData, setFormData] = useState({
        serviceType: '', // Change servicetype to Servicetyep
        firstName: '',
        mobile: '',
        email: '',
        address: '',
        pincode: '',
        dob: '',
        status:'Pending',
        createdBy:0
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    // Handle input change for form fields
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value, // Dynamically update the form field
        });
    };



    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission
        setLoading(true); // Show loading indicator
        setError(null); // Clear previous errors
        setSuccess(null); // Clear previous success messages

        try {
            console.log('Submitting data:', formData); // Debug submitted data
            await addServiceData(formData); // Submit data to the API

            // Display success message
            // alert('Service data submitted successfully!');
            setSuccess('Service data submitted successfully!'); // Optional UI success message

            // Reset form fields, including resetting Servicetyep to an empty string
            setFormData({
                serviceType: '', // Change servicetype to Servicetyep
                firstName: '',
                mobile: '',
                email: '',
                address: '',
                pincode: '',
                dob: '',
                status:'Pending',
                createdBy:0
            });
        } catch (error) {
            console.error('Error submitting data:', error); // Log error details
            setError('Failed to submit service data. Please try again later.');
            // alert('Failed to submit service data.');
        } finally {
            setLoading(false); // Hide loading indicator
        }
    };



    return (
        <section id="contact" className="contact section light-background">
            <div className="container" data-aos="fade-up" data-aos-delay={100}>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">

                                {/* Success/Error Messages */}
                                {success && (
                                    <div className="col-md-12">
                                        <div className="alert alert-success">{success}</div>
                                    </div>
                                )}
                                {error && (
                                    <div className="col-md-12">
                                        <div className="alert alert-danger">{error}</div>
                                    </div>
                                )}
                                <form onSubmit={handleSubmit}>
                                    <div className="row gy-4">
                                        {/* Service Selection Dropdown */}
                                        <div className="col-md-6 col-lg-4">
                                            <label htmlFor="service-field" className="pb-2">Select a Service</label>
                                            <select
                                                name="serviceType" // Ensure this matches the key in formData
                                                id="service-field"
                                                className="form-control border border-secondary"
                                                value={formData.serviceType} // Bind the dropdown to formData.Servicetyep
                                                onChange={handleChange} // Update formData when the dropdown value changes
                                                required
                                            >
                                                <option value="">Select a service</option> {/* Default option */}
                                                <option value="Credit Card">Credit Card</option>
                                                <option value="Loan">Loan</option>
                                                <option value="Insurance">Insurance</option>
                                                <option value="Credit Card Swipe">Credit Card Swipe</option>
                                                <option value="Passport Services">Passport Services</option>
                                                <option value="Pan Card Services">Pan Card Services</option>
                                                <option value="Udhyam">Udhyam</option>
                                                <option value="Voter ID Card">Voter ID Card</option>
                                                <option value="Income Tax Services">Income Tax Services</option>
                                                <option value="E-shram">E-shram</option>
                                            </select>



                                        </div>

                                        {/* First Name Field */}
                                        <div className="col-md-6 col-lg-4">
                                            <label htmlFor="name-field" className="pb-2">Your Name</label>
                                            <input
                                                type="text"
                                                name="firstName"
                                                id="name-field"
                                                className="form-control border border-secondary"
                                                value={formData.firstName}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        {/* Email Field */}
                                        <div className="col-md-6 col-lg-4">
                                            <label htmlFor="email-field" className="pb-2">Your Email</label>
                                            <input
                                                type="email"
                                                className="form-control border border-secondary"
                                                name="email"
                                                id="email-field"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        {/* Mobile Number Field */}
                                        <div className="col-md-6 col-lg-4">
                                            <label htmlFor="mobile-field" className="pb-2">Mobile No.</label>
                                            <input
                                                type="text"
                                                className="border border-secondary form-control"
                                                name="mobile"
                                                id="mobile-field"
                                                value={formData.mobile}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        {/* Pincode Field */}
                                        <div className="col-md-6 col-lg-4">
                                            <label htmlFor="pincode-field" className="pb-2">Pincode</label>
                                            <input
                                                type="text"
                                                className="form-control border border-secondary"
                                                name="pincode"
                                                id="pincode-field"
                                                value={formData.pincode}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        {/* Birthdate Field */}
                                        <div className="col-md-6 col-lg-4">
                                            <label htmlFor="birthdate-field" className="pb-2">Birthdate</label>
                                            <input
                                                type="date"
                                                className="form-control border border-secondary"
                                                name="dob"
                                                id="birthdate-field"
                                                value={formData.dob}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        {/* Address Field */}
                                        <div className="col-md-12">
                                            <label htmlFor="address-field" className="pb-2">Address</label>
                                            <textarea
                                                className="form-control border border-secondary"
                                                name="address"
                                                rows={5}
                                                id="address-field"
                                                value={formData.address}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        {/* Submit Button */}
                                        <div className="col-md-12 d-grid">
                                            <button
                                                type="submit"
                                                className="btn btn-sm btn-primary"
                                                disabled={loading}
                                            >
                                                {loading ? 'Submitting...' : 'Apply'}
                                            </button>
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Servicedata;
